import React, { useContext } from 'react';
import UserProvider from '../../context/UserContext';
import '../../dash.css'
import { useAlert } from "react-alert";

const CardEmail = () => {
    const alert = useAlert();
    const Data = useContext(UserProvider.context);
    const memberData = Data.member
    
    function alertError(message){
        if (document.getElementById('__react-alert__').children.length === 0) {
            alert.error(message)
        }
    }

    function ButtonSubmit(e){
        var input = document.getElementsByClassName('mail-input')[0].value;
        validateMail(input)
    }

    function validateMail(email){
        let valid = true;
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        if(email === memberData.email){
            alertError("E-mail already used")
            valid = false;
        }
        else if(!email.match(mailformat)){
            alertError("Invalid e-mail")
            valid = false;
        }
        if(valid){
            updateMail(email)
        }
    }

    function CloseEmailCard(){
        var x = document.getElementById("email");
        if(x.style.display === "flex") {
            x.style.display = "none";
        }

        var y = document.getElementById("overlay");
        if(y.style.display === "flex") {
            y.style.display = "none";
        }
    }

    function BuildMember(email){

        return {
            "role": memberData.role,
            "stripe_customer": memberData.stripe_customer,
            "next_renewal_date": memberData.next_renewal_date,
            "system_name": memberData.system_name,
            "subscription_active": memberData.subscription_active,
            "download": memberData.download,
            "monthly": memberData.monthly,
            "discord_name": memberData.discord_name,
            "plan":memberData.plan,
            "key": memberData.key,
            "email": email,
        }
    }

    async function updateMail(email){
        document.getElementsByClassName('update-button')[0].disabled = true;
        const url = `${process.env.REACT_APP_API_URL}/set-email/`
        const form = new FormData()
        form.append('email', email)

        fetch(url, {
            credentials: "include",
            method: 'POST',
            body: form
            })
            .then(function (response) {
                if(response.status === 200){
                    if (document.getElementById('__react-alert__').children.length === 0) {
                        alert.success("E-mail updated")
                    }
                    let new_member = BuildMember(email)
                    Data.setMember(new_member)
                    CloseEmailCard()
                    document.getElementsByClassName('update-button')[0].disabled = false;
                }
                else{
                    document.getElementsByClassName('update-button')[0].disabled = false;
                    alertError("An error ocurred")
                }
            })
            .catch(err => {
                document.getElementsByClassName('update-button')[0].disabled = false;
                alertError("An error ocurred")
                console.log(err)
            });
    }

    return(
        <div className="card-component mail-card">
            <div className="mail-card-content">
                <div>
                    <h4 className="card-title">Update e-mail</h4>
                    <div className="close-button-holder">
                        <button className="close-button" onClick={CloseEmailCard}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    <div className="mail-input-holder">
                        <input type="text" className="mail-input" placeholder={memberData.email} defaultValue={memberData.email} maxLength={40} autoComplete="off"></input>
                    </div>
                    <div className="mail-disclaimer">
                        <i className="fas fa-exclamation-circle"></i><h6 className="no-margin">This mail will be used to send updates.</h6>
                    </div>
                    <div className="update-mail">
                        <button className="update-button pink-button" onClick={ButtonSubmit}>
                            <h4>Update</h4>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CardEmail;